import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { resolveMagicLinkShortUrl } from '@/services/magicLinkService';

const MagicLinkShortUrlPage = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) {
      setError('This link is missing its code.');
      return;
    }

    let cancelled = false;

    resolveMagicLinkShortUrl(code)
      .then((result) => {
        if (!cancelled) {
          navigate(result.targetPath, { replace: true });
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'This link is unavailable.');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        textAlign: 'center'
      }}
    >
      {error ? (
        <Typography color="text.secondary">{error}</Typography>
      ) : (
        <Box sx={{ display: 'grid', gap: 2, justifyItems: 'center' }}>
          <CircularProgress size={28} />
          <Typography color="text.secondary">Opening link...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default MagicLinkShortUrlPage;
